import React, { Component } from 'react';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';

import './InquiryList.scss';
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import moment from "moment/moment";
import ModalLoading from "../../../components/common/ModalLoading";
import {
  Badge,
  Button,
  ButtonGroup,
  FormTextarea,
  Modal,
  ModalBody,
  ModalHeader
} from "shards-react";
import { toast } from "react-toastify";
import { reactLocalStorage as Storage } from "reactjs-localstorage";

@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))
@inject(({ board }) => ({getBoardList: board.getBoardList, updateBoard: board.updateBoard, removeBoard: board.removeBoard}))
@inject(({ AOA }) => ({ csLogin: AOA.csLogin }))
@inject(({ common }) => ({ uploadImages: common.uploadImages }))

@observer
class InquiryList extends Component {

  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {};
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  @observable storageCfg = {
    is: true
  };

  @observable listParams = {
    page: 1,
    limit: 100,
    displayStatus: 100,
    searchParams: {
      status: 'all',
      boardName: 'inquiry' // 문의하기만 조회
    }
  };
  @observable list = {};
  @observable searchFormValue = {
    status: 'all',
    keyword: ''
  };

  @observable modals = {
    isDetail: false,
    detailData: {},
  };

  @observable isUploadingCommentFile = false;

  // 예약 답변 상태
  @observable reservation = {
    enabled: false,
    mode: 'businessHour', // 'businessHour' | 'afterHours' | 'custom'
    afterHours: 1,        // 1 | 2 | 3
    customAt: ''          // datetime-local 문자열 (YYYY-MM-DDTHH:mm)
  };

  constructor(props) {
    super(props);
    this.init();
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
  }

  @action
  init = async (key) => {
    if (this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.teamUser.email = this.teamUser.email ? this.teamUser.email : this.teamUser.emailId;
      this.store = this.props.me.store;
      this.listParams.store_id = this.store._id;

      let storageCfg = await Storage.getObject('storageCfg');
      if (storageCfg.is) {
        this.storageCfg = storageCfg;
      }

      this.permissions = this.props.me.permissions;
      if (this.teamUser.isSuper && this.listParams.store_id) {
        this.urlParamsToListParams();
      }
    }
    else {
      if (Storage.get('token')) {
      }
    }
  };

  @action
  getList = async () => {
    Storage.set('limitInquiryList', this.listParams.limit);
    if (this.listParams.store_id) {
      this.list = await this.props.getBoardList(this.listParams);
      console.log(this.list.docs[0]);
      this.isLoading = false;
    }
    else {
      this.isLoading = false;
    }
  };

  urlParamsToListParams = function () {
    let searchFormValueArr = {};
    for (const key of this.urlParams.keys()) {
      if (['page'].indexOf(key) > -1 || ['limit'].indexOf(key) > -1) {
        this.listParams[key] = parseInt(this.urlParams.get(key));
      }
      else {
        if (key.indexOf('__') > -1) {
          let keyArr = key.split('__');
          if (!searchFormValueArr[keyArr[0]]) { searchFormValueArr[keyArr[0]] = {}; }
          searchFormValueArr[keyArr[0]][keyArr[1]] = true;
        }
        else {
          if (this.urlParams.get(key) === "true") {
            this.searchFormValue[key] = true;
            this.listParams.searchParams[key] = true;
          }
          else if (this.urlParams.get(key) === "false") {
            this.searchFormValue[key] = false;
            this.listParams.searchParams[key] = false;
          }
          else {
            this.searchFormValue[key] = this.urlParams.get(key);
            this.listParams.searchParams[key] = this.urlParams.get(key);
          }
        }
      }
    }

    for (let key in searchFormValueArr) {
      if (searchFormValueArr[key].all) {
        for (let deKey in this.searchFormValue[key]) {
          this.searchFormValue[key][deKey] = true;
        }
      }
      else {
        for (let deKey in this.searchFormValue[key]) {
          if (searchFormValueArr[key][deKey]) {
            this.searchFormValue[key][deKey] = true;
          }
          else {
            this.searchFormValue[key][deKey] = false;
          }
        }
      }
      this.listParams.searchParams[key] = searchFormValueArr[key];
    }

    this.getList();
  };

  onChangeValue = async (event) => {
    const { name, value } = event.target;
    this.teamUser[name] = value;
  };

  onChangeSearchValue = async (event, obj) => {
    const { name, value, type } = event.target;
    let newValue;
    if (type === 'checkbox') {
      if (value) {
        newValue = !JSON.parse(value);
      }
      else {
        newValue = true;
      }
    }
    else {
      newValue = value;
    }

    if (obj) {
      obj[name] = newValue;
    }
    else {
      this.searchFormValue[name] = newValue;
    }

    if (name === "sort") {
      this.listParams.sort = newValue;
      this.getList();
    }
  };

  modalToggle = function (target, data) {
    let _this = this;
    if (!target) {
      for (var i in _this.modals) {
        if (i.indexOf('is') === 0) {
          _this.modals[i] = false;
        }
      }
    }
    else {
      _this.modals[target] = !this.modals[target];
    }

    if (data) {
      if (target === 'isDetail' && data) {
        _this.modals.detailData = data;
        _this.resetReservation(data);
      }
      else {
        _this.modals.data = data;
      }
    }
  };

  // 예약 답변 UI 초기화 — 이미 예약 대기중인 문의면 값을 채워둠
  resetReservation = (data) => {
    if (data && data.scheduledReplyStatus === 'pending' && data.scheduledReplyAt) {
      this.reservation = {
        enabled: true,
        mode: 'custom',
        afterHours: 1,
        customAt: moment(data.scheduledReplyAt).format('YYYY-MM-DDTHH:mm')
      };
    }
    else {
      this.reservation = { enabled: false, mode: 'businessHour', afterHours: 1, customAt: '' };
    }
  };

  // 선택된 예약 방식으로 발송 시각(moment) 계산
  computeScheduledAt = () => {
    const r = this.reservation;
    if (r.mode === 'businessHour') {
      // 다음 영업시간(오전 10시). 이미 지났으면 다음 날 10시
      let t = moment().hour(10).minute(0).second(0).millisecond(0);
      if (t.isSameOrBefore(moment())) {
        t.add(1, 'day');
      }
      return t;
    }
    else if (r.mode === 'afterHours') {
      return moment().add(parseInt(r.afterHours, 10) || 1, 'hours');
    }
    else { // custom
      return r.customAt ? moment(r.customAt) : null;
    }
  };

  updateBoard = async (item, status) => {
    let params = {
      id: item._id,
      store_id: item.store_id._id,
      shopNo: item.shopNo,
      boardName: item.boardName,
      status: status,
      notifyAuthor: true
    };
    console.log(params);
    let res = await this.props.updateBoard(params);
    if (res.errors && res.errors.length > 0) {
      toast(res.errors[0].message);
    } else {
      toast('상태가 업데이트되었습니다.');
      this.getList();
    }
  };

  onCommentFileChange = async (event) => {
    const inputEl = event.target;
    const files = inputEl.files;
    if (!files || files.length === 0) return;

    const maxFiles = 5;
    const current = this.modals.detailData.commentAttachments || [];
    if (current.length + files.length > maxFiles) {
      toast(`첨부는 최대 ${maxFiles}개까지 가능합니다.`);
      if (inputEl) inputEl.value = '';
      return;
    }

    this.isUploadingCommentFile = true;
    try {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (file.size / 1000000 > 10) {
          toast(`${file.name} 은(는) 10MB를 초과하여 첨부할 수 없습니다.`);
          continue;
        }

        const formData = new FormData();
        formData.append('file', file);
        const res = await this.props.uploadImages(formData);
        if (res && Array.isArray(res) && res[0] && res[0].fullPath) {
          if (!this.modals.detailData.commentAttachments) {
            this.modals.detailData.commentAttachments = [];
          }
          const isImage = file.type && file.type.startsWith('image/');
          this.modals.detailData.commentAttachments.push({
            type: isImage ? 'image' : 'file',
            url: res[0].fullPath,
            size: file.size,
            meta: { filename: file.name, mime: file.type }
          });
        } else {
          toast(`${file.name} 업로드에 실패했습니다.`);
        }
      }
      toast.success('파일이 첨부되었습니다.');
    } catch (err) {
      console.error(err);
      toast('파일 업로드 중 오류가 발생했습니다.');
    } finally {
      this.isUploadingCommentFile = false;
      if (inputEl) inputEl.value = '';
    }
  };

  removeCommentAttachment = (index) => {
    if (!this.modals.detailData.commentAttachments) return;
    this.modals.detailData.commentAttachments.splice(index, 1);
  };

  updateComment = async (item) => {
    const useReservation = this.reservation.enabled;
    let scheduledReplyAt = null;

    if (useReservation) {
      const at = this.computeScheduledAt();
      if (!at || !at.isValid()) {
        toast('예약 발송 시간을 선택해주세요.');
        return false;
      }
      if (at.isSameOrBefore(moment())) {
        toast('예약 시간은 현재 시각 이후여야 합니다.');
        return false;
      }
      scheduledReplyAt = at.toISOString();
    }

    let params = {
      id: item._id,
      store_id: item.store_id._id,
      shopNo: item.shopNo,
      boardName: item.boardName,
      comment: item.comment,
      commentAttachments: (item.commentAttachments || []).map(f => ({
        type: f.type, url: f.url, key: f.key, size: f.size, meta: f.meta
      })),
      // 예약이면 'scheduled', 즉시 저장이면 '완료'
      status: useReservation ? 'scheduled' : 'completed',
      // 즉시 저장이면 처리 시각 기록, 예약이면 발송 시 크론이 기록
      processedAt: useReservation ? null : new Date().toISOString(),
      // 예약 정보 (즉시 저장이면 null 로 이전 예약을 해제)
      scheduledReplyAt: scheduledReplyAt,
      scheduledReplyStatus: useReservation ? 'pending' : null,
      // 예약이면 지금 메일을 보내지 않음
      notifyAuthor: !useReservation
    };
    console.log(params);
    let res = await this.props.updateBoard(params);
    if (res.errors && res.errors.length > 0) {
      toast(res.errors[0].message);
      return false;
    } else {
      if (useReservation) {
        toast.success(`답변이 저장되었습니다. ${this.computeScheduledAt().format('YYYY.MM.DD HH:mm')}에 발송 예약되었습니다.`);
      } else {
        toast.success('답변이 저장되었습니다. 상태가 "완료"로 변경되었습니다.');
      }
      this.getList();
      return true;
    }
  };

  updateModalComment = async () => {
    const ok = await this.updateComment(this.modals.detailData);
    if (ok) {
      this.modals.isDetail = false;
    }
  };

  // 예약 답변 발송 취소
  cancelScheduledReply = async (item) => {
    if (!window.confirm('예약된 답변 발송을 취소하시겠습니까?')) {
      return;
    }
    let params = {
      id: item._id,
      store_id: item.store_id._id,
      shopNo: item.shopNo,
      boardName: item.boardName,
      status: 'in_progress',
      scheduledReplyAt: null,
      scheduledReplyStatus: 'canceled',
      notifyAuthor: false
    };
    let res = await this.props.updateBoard(params);
    if (res.errors && res.errors.length > 0) {
      toast(res.errors[0].message);
    } else {
      toast.success('예약 발송이 취소되었습니다.');
      this.reservation.enabled = false;
      this.modals.isDetail = false;
      this.getList();
    }
  };

  deleteInquiry = async (item) => {
    if (window.confirm('정말로 이 문의를 삭제하시겠습니까?')) {
      let params = {
        id: item._id
      };
      let res = await this.props.removeBoard(params);
      if (res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      } else {
        toast('문의가 삭제되었습니다.');
        this.getList();
      }
    }
  };

  csLogin = async (item) => {
    let params = {
      id: item.store_id._id,
      platformId: item.store_id.platformId,
      emailId: item.store_id.email
    }
    console.log(params)
    await this.props.csLogin(params);
    await Storage.remove("shops");
    window.location.href = "/reviewList";
  };

  onChangeModalInputs = async (event, targetObj) => {
    let { name, value } = event.target;
    targetObj[name] = value;
  };

  render() {
    let _this = this;

    function Pagination() {
      let result = [];
      let totalPages = _this.list.totalPages;
      let curPageNum = _this.list.page;
      let startNum = (parseInt((curPageNum - 1) / 10) * 10) + 1;
      let endNum = startNum + 9 < totalPages ? startNum + 9 : totalPages;

      let urlParamsArr = new URLSearchParams(window.location.search);
      urlParamsArr.delete('page');
      let urlParams = '?' + urlParamsArr.toString();

      let rendering = () => {
        for (let i = startNum; i <= endNum; i++) {
          if (i === curPageNum) {
            result.push(<li key={i} className="on"><a href={urlParams + "&page=" + i}>{i}</a></li>);
          }
          else {
            result.push(<li key={i}><a href={urlParams + "&page=" + i}>{i}</a></li>);
          }
        }
        return result;
      };

      if (_this.list && _this.list.totalPages) {
        return (
          <div className="pagination">
            <ul>
              {curPageNum !== 1 ? <li className="btn-page-first"><a href={urlParams + "&page=1"}><FeatherIcon icon="chevrons-left" className="nd-icon" /></a></li> : null}
              {startNum - 1 > 0 ? <li className="btn-page-prev"><a href={urlParams + "&page=" + (startNum - 1)}><FeatherIcon icon="chevron-left" className="nd-icon" /></a></li> : null}
              {rendering()}
              {endNum !== totalPages ? <li className="btn-page-next"><a href={urlParams + "&page=" + (startNum + 10)}><FeatherIcon icon="chevron-right" className="nd-icon" /></a></li> : null}
              {curPageNum !== totalPages ? <li className="btn-page-last"><a href={urlParams + "&page=" + totalPages}><FeatherIcon icon="chevrons-right" className="nd-icon" /></a></li> : null}
            </ul>
          </div>);
      }
      else {
        return (<></>);
      }
    }

    function GetStatusBadge(props) {
      let statusDom = '';
      switch (props.status) {
        case "published":
          statusDom = <Badge theme="secondary">대기중</Badge>;
          break;
        case "in_progress":
          statusDom = <Badge theme="info">처리중</Badge>;
          break;
        case "completed":
          statusDom = <Badge theme="success">완료</Badge>;
          break;
        case "scheduled":
          statusDom = <Badge theme="primary">예약됨</Badge>;
          break;
        case "rejected":
          statusDom = <Badge theme="warning">보류</Badge>;
          break;
        default:
          statusDom = <Badge outline theme="info">{props.status}</Badge>;
          break;
      }
      return statusDom;
    }

    function formatFileSize(size) {
      if (!size && size !== 0) return '';
      if (size < 1024) return size + ' B';
      if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
      return (size / (1024 * 1024)).toFixed(1) + ' MB';
    }

    function AttachmentList(props) {
      const items = props.items || [];
      if (!items.length) return null;
      return (
        <ul className="inquiry-attachments">
          {items.map((file, idx) => {
            const filename = (file && file.meta && file.meta.filename) || (file && file.name) || (file && file.url ? file.url.split('/').pop() : ('첨부 ' + (idx + 1)));
            const isImage = file && (file.type === 'image' || (typeof file.type === 'string' && file.type.startsWith('image/'))) && file.url;
            return (
              <li key={idx} className="inquiry-attachments__item">
                {isImage ? (
                  <a href={file.url} target="_blank" rel="noopener noreferrer">
                    <img src={file.url} alt={filename} className="inquiry-attachments__thumb" />
                  </a>
                ) : (
                  <FeatherIcon icon={file && file.type === 'video' ? 'film' : file && file.type === 'link' ? 'link' : 'paperclip'} size="14" />
                )}
                <a
                  href={file && file.url ? file.url : '#'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inquiry-attachments__name"
                  onClick={e => { if (!file || !file.url) e.preventDefault(); }}
                >
                  {filename}
                </a>
                {file && file.size ? (
                  <span className="inquiry-attachments__size">({formatFileSize(file.size)})</span>
                ) : null}
                {props.onRemove ? (
                  <button
                    type="button"
                    className="inquiry-attachments__remove"
                    onClick={() => props.onRemove(idx)}
                    title="삭제"
                  >
                    <FeatherIcon icon="x" size="12" />
                  </button>
                ) : null}
              </li>
            );
          })}
        </ul>
      );
    }

    function GetInquiryType(props) {
      let typeDom = '';
      switch (props.type) {
        case "general":
          typeDom = <Badge theme="secondary">일반 문의</Badge>;
          break;
        case "technical":
          typeDom = <Badge theme="primary">기술 문의</Badge>;
          break;
        case "billing":
          typeDom = <Badge theme="warning">결제 문의</Badge>;
          break;
        case "feature":
          typeDom = <Badge theme="info">기능 개선</Badge>;
          break;
        case "bug":
          typeDom = <Badge theme="danger">버그 신고</Badge>;
          break;
        case "other":
          typeDom = <Badge theme="light">기타</Badge>;
          break;
        default:
          typeDom = <Badge outline theme="secondary">{props.type}</Badge>;
          break;
      }
      return typeDom;
    }

    return (
      <div className="main-content">
        <PageTitle />
        <div className="user-list-box">
          <div className="section-box">
            <form id="" target="" className="">
              <div className="user-list-table">
                <div className="user-pick-list">
                  <div className="pick-list-count">
                    문의 내역 <span>{this.list.totalDocs || 0}</span>개
                  </div>
                  <div className="choice-num-view">
                    <select name="limit"
                            value={this.listParams.limit}
                            onChange={event => {
                              this.listParams.limit = parseInt(event.target.value);
                              this.onChangeSearchValue(event, this.listParams);
                            }}
                            className="">
                      <option value="50">50개씩 보기</option>
                      <option value="100">100개씩 보기</option>
                      <option value="200">200개씩 보기</option>
                    </select>
                  </div>
                </div>
                <table className="store-list">
                  <colgroup>
                    <col width="15%" />
                    <col width="" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="12%" />
                    <col width="12%" />
                    <col width="15%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>쇼핑몰</th>
                      <th>문의 제목</th>
                      <th>문의 유형</th>
                      <th>상태</th>
                      <th>신청일</th>
                      <th>답변일</th>
                      <th>액션</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.list && this.list.docs && this.list.docs.length > 0 ?
                      this.list.docs.map((item, i) => (
                        <tr key={i}>
                          <td>
                            {item.store_id && item.store_id.name ? item.store_id.name : '-'}
                          </td>
                          <td>
                            <div style={{maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                              {item.title || '-'}
                            </div>
                          </td>
                          <td className="text-center">
                            <GetInquiryType type={item.inquiryType} />
                          </td>
                          <td className="text-center">
                            <GetStatusBadge status={item.status} />
                          </td>
                          <td>{moment(item.createdAt).format('YYYY.MM.DD HH:mm')}</td>
                          <td>
                            {item.processedAt
                              ? moment(item.processedAt).format('YYYY.MM.DD HH:mm')
                              : (item.scheduledReplyStatus === 'pending' && item.scheduledReplyAt)
                                ? <span style={{color: '#6D28D9'}}>예약 {moment(item.scheduledReplyAt).format('MM.DD HH:mm')}</span>
                                : '-'}
                          </td>
                          <td className="text-center">
                            <ButtonGroup size="sm">
                              <Button onClick={() => this.modalToggle('isDetail', item)}>상세</Button>
                              <Button theme="danger" onClick={() => this.deleteInquiry(item)}>삭제</Button>
                            </ButtonGroup>
                          </td>
                        </tr>))
                      :
                      <tr>
                        <td colSpan={7} className="text-center">문의 내역이 없습니다</td>
                      </tr>
                    }
                  </tbody>
                </table>
                <Pagination />
              </div>
            </form>
          </div>
        </div>

        <Modal size="lg" className='modal-inquiry-detail' open={this.modals.isDetail} toggle={() => this.modals.isDetail = false} centered={true}>
          <ModalHeader toggle={() => this.modals.isDetail = false}>문의 상세 및 답변</ModalHeader>
          <ModalBody className="history-window-popup">
            <div className="history-popup-contents">
              {this.modals.detailData && this.modals.detailData.store_id ? (
                <table>
                  <colgroup>
                    <col style={{ width: '15%' }} />
                    <col style={{ width: '35%' }} />
                    <col style={{ width: '15%' }} />
                    <col style={{ width: '35%' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>쇼핑몰</th>
                      <td>{this.modals.detailData.store_id.name}</td>
                      <th>상태</th>
                      <td><GetStatusBadge status={this.modals.detailData.status} /></td>
                    </tr>
                    <tr>
                      <th>담당자</th>
                      <td>{this.modals.detailData.authorName || '-'}</td>
                      <th>연락처</th>
                      <td>{this.modals.detailData.contact || '-'}</td>
                    </tr>
                    <tr>
                      <th>이메일</th>
                      <td colSpan="3">{this.modals.detailData.email || '-'}</td>
                    </tr>
                    <tr>
                      <th>문의 유형</th>
                      <td><GetInquiryType type={this.modals.detailData.inquiryType} /></td>
                      <th>신청일</th>
                      <td>{moment(this.modals.detailData.createdAt).format('YYYY.MM.DD HH:mm')}</td>
                    </tr>
                    <tr>
                      <th>문의 제목</th>
                      <td colSpan="3">{this.modals.detailData.title || '-'}</td>
                    </tr>
                    <tr>
                      <th>문의 내용</th>
                      <td colSpan="3">
                        <div style={{whiteSpace: 'pre-wrap', minHeight: '100px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px'}}>
                          {this.modals.detailData.content || '-'}
                        </div>
                      </td>
                    </tr>
                    {Array.isArray(this.modals.detailData.attachments) && this.modals.detailData.attachments.length > 0 && (
                      <tr>
                        <th>첨부 파일</th>
                        <td colSpan="3">
                          <AttachmentList items={this.modals.detailData.attachments} />
                        </td>
                      </tr>
                    )}
                    <tr>
                      <th>답변</th>
                      <td colSpan="3">
                        <FormTextarea
                          name="comment"
                          value={this.modals.detailData.comment || ''}
                          onChange={event => this.onChangeModalInputs(event, this.modals.detailData)}
                          placeholder="답변 내용을 입력해주세요."
                          rows="6"
                          style={{width: '100%'}}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>답변 첨부</th>
                      <td colSpan="3">
                        <div className="inquiry-attachments-editor">
                          <input
                            type="file"
                            id="commentAttachments"
                            multiple
                            disabled={this.isUploadingCommentFile}
                            onChange={this.onCommentFileChange}
                            style={{display: 'none'}}
                          />
                          <label htmlFor="commentAttachments" className="btn btn-outline-secondary btn-sm mb-2">
                            <FeatherIcon icon="paperclip" size="14" /> 파일 첨부 (최대 5개 · 10MB 이하)
                          </label>
                          {this.isUploadingCommentFile && <span className="ml-2 text-muted">업로드 중...</span>}
                          <AttachmentList
                            items={this.modals.detailData.commentAttachments || []}
                            onRemove={this.removeCommentAttachment}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>예약 발송</th>
                      <td colSpan="3">
                        <div className="inquiry-reservation">
                          <label style={{display: 'inline-flex', alignItems: 'center', cursor: 'pointer', marginBottom: 0}}>
                            <input
                              type="checkbox"
                              checked={this.reservation.enabled}
                              onChange={e => this.reservation.enabled = e.target.checked}
                              style={{marginRight: '6px'}}
                            />
                            <b>예약 발송 사용</b>
                            <span style={{color: '#888', marginLeft: '6px', fontWeight: 400}}>(지정한 시간에 답변 알림 메일을 발송)</span>
                          </label>

                          {this.reservation.enabled && (
                            <div className="inquiry-reservation__options" style={{marginTop: '12px'}}>
                              {/* 3가지 방식 택일 (세그먼트 버튼) */}
                              <div style={{display: 'flex', width: '100%', gap: '8px'}}>
                                {[
                                  {key: 'businessHour', label: '영업시간', sub: '오전 10시'},
                                  {key: 'afterHours', label: 'N시간 후', sub: '1·2·3시간'},
                                  {key: 'custom', label: '특정 시간', sub: '직접 지정'}
                                ].map(opt => {
                                  const active = this.reservation.mode === opt.key;
                                  return (
                                    <button
                                      key={opt.key}
                                      type="button"
                                      onClick={() => this.reservation.mode = opt.key}
                                      style={{
                                        flex: 1,
                                        padding: '10px 8px',
                                        borderRadius: '6px',
                                        border: active ? '2px solid #6D28D9' : '1px solid #d1d5db',
                                        background: active ? '#F5F3FF' : '#fff',
                                        color: active ? '#6D28D9' : '#555',
                                        fontWeight: active ? 700 : 500,
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'all .15s'
                                      }}
                                    >
                                      <div style={{fontSize: '14px'}}>{active ? '✓ ' : ''}{opt.label}</div>
                                      <div style={{fontSize: '11px', color: active ? '#8B5CF6' : '#999', marginTop: '2px'}}>{opt.sub}</div>
                                    </button>
                                  );
                                })}
                              </div>

                              {/* 선택한 방식의 상세 설정 */}
                              <div style={{marginTop: '12px', padding: '14px', border: '1px solid #e5e7eb', borderRadius: '6px', background: '#fafafa'}}>
                                {this.reservation.mode === 'businessHour' && (
                                  <div style={{color: '#555'}}>다음 영업일 <b>오전 10시</b>에 답변 알림이 발송됩니다.</div>
                                )}

                                {this.reservation.mode === 'afterHours' && (
                                  <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
                                    <span style={{marginRight: '10px', color: '#555'}}>지금부터</span>
                                    <ButtonGroup size="sm">
                                      {[1, 2, 3].map(h => (
                                        <Button
                                          key={h}
                                          theme={parseInt(this.reservation.afterHours, 10) === h ? 'primary' : 'light'}
                                          onClick={() => this.reservation.afterHours = h}
                                        >
                                          {h}시간
                                        </Button>
                                      ))}
                                    </ButtonGroup>
                                    <span style={{marginLeft: '10px', color: '#555'}}>후에 발송</span>
                                  </div>
                                )}

                                {this.reservation.mode === 'custom' && (
                                  <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
                                    <span style={{marginRight: '10px', color: '#555'}}>발송 시각</span>
                                    <input
                                      type="datetime-local"
                                      value={this.reservation.customAt}
                                      onChange={e => this.reservation.customAt = e.target.value}
                                      style={{padding: '5px 8px', border: '1px solid #ccc', borderRadius: '4px'}}
                                    />
                                  </div>
                                )}

                                {/* 발송 예정 미리보기 */}
                                {(() => {
                                  const at = this.computeScheduledAt();
                                  const valid = at && at.isValid() && at.isAfter(moment());
                                  return (
                                    <div style={{marginTop: '12px', paddingTop: '10px', borderTop: '1px dashed #ddd', fontWeight: 700, color: valid ? '#6D28D9' : '#dc3545'}}>
                                      {at && at.isValid()
                                        ? (valid
                                            ? `📅 발송 예정  ${at.format('YYYY.MM.DD HH:mm')}`
                                            : '⚠️ 예약 시간은 현재 시각 이후여야 합니다.')
                                        : '⚠️ 발송 시간을 선택해주세요.'}
                                    </div>
                                  );
                                })()}
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>) : null}

              <div className="text-center mt-3">
                <ButtonGroup>
                  <Button theme="success" onClick={() => this.csLogin(this.modals.detailData)}>
                    해당 스토어 로그인
                  </Button>
                  {this.modals.detailData && this.modals.detailData.scheduledReplyStatus === 'pending' ? (
                    <Button theme="warning" onClick={() => this.cancelScheduledReply(this.modals.detailData)}>
                      예약 취소
                    </Button>
                  ) : null}
                  <Button theme="primary" onClick={e => this.updateModalComment()}>
                    {this.reservation.enabled ? '예약 저장' : '답변 저장'}
                  </Button>
                  <Button theme="light" onClick={() => this.modals.isDetail = false}>
                    닫기
                  </Button>
                </ButtonGroup>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <ModalLoading isLoading={this.isLoading} />
      </div>
    )
  }
}

export default InquiryList;
